import api from './api';

class VoipService {
  // Extension Management
  async getMyExtension() {
    const response = await api.get('/voip/extensions/me');
    return response.data;
  }

  async getExtension(extensionId) {
    const response = await api.get(`/voip/extensions/${extensionId}`);
    return response.data;
  }

  async listExtensions() {
    const response = await api.get('/voip/extensions');
    return response.data;
  }

  async updateExtension(extensionId, updateData) {
    const response = await api.patch(`/voip/extensions/${extensionId}`, updateData);
    return response.data;
  }

  async updateExtensionStatus(extensionId, status, statusMessage = null) {
    const response = await api.post(`/voip/extensions/${extensionId}/status`, null, {
      params: { status, status_message: statusMessage }
    });
    return response.data;
  }

  // Call Management
  async makeCall(extensionId, toNumber, contactId = null, caseId = null) {
    const response = await api.post('/voip/calls/make', {
      extension_id: extensionId,
      to_number: toNumber,
      contact_id: contactId,
      case_id: caseId
    });
    return response.data;
  }

  async getCallLogs(filters = {}) {
    const response = await api.get('/voip/calls', { params: filters });
    return response.data;
  }

  async getCall(callId) {
    const response = await api.get(`/voip/calls/${callId}`);
    return response.data;
  }

  async updateCall(callId, updateData) {
    const response = await api.patch(`/voip/calls/${callId}`, updateData);
    return response.data;
  }

  async transferCall(callUuid, transferData) {
    const response = await api.post(`/voip/calls/${callUuid}/transfer`, transferData);
    return response.data;
  }

  async holdCall(callUuid, hold) {
    const response = await api.post(`/voip/calls/${callUuid}/hold`, { hold });
    return response.data;
  }

  // Voicemail Management
  async getVoicemails(filters = {}) {
    const response = await api.get('/voip/voicemails', { params: filters });
    return response.data;
  }

  async getVoicemail(voicemailId) {
    const response = await api.get(`/voip/voicemails/${voicemailId}`);
    return response.data;
  }

  async updateVoicemail(voicemailId, updateData) {
    const response = await api.patch(`/voip/voicemails/${voicemailId}`, updateData);
    return response.data;
  }

  async markVoicemailRead(voicemailId) {
    return this.updateVoicemail(voicemailId, { is_read: true });
  }

  async archiveVoicemail(voicemailId) {
    return this.updateVoicemail(voicemailId, { is_archived: true });
  }

  // Speed Dials
  async getSpeedDials() {
    const response = await api.get('/voip/speed-dials');
    return response.data;
  }

  async createSpeedDial(speedDialData) {
    const response = await api.post('/voip/speed-dials', speedDialData);
    return response.data;
  }

  async updateSpeedDial(speedDialId, updateData) {
    const response = await api.patch(`/voip/speed-dials/${speedDialId}`, updateData);
    return response.data;
  }

  async deleteSpeedDial(speedDialId) {
    await api.delete(`/voip/speed-dials/${speedDialId}`);
  }

  // Statistics
  async getCallStatistics(filters = {}) {
    const response = await api.get('/voip/statistics/calls', { params: filters });
    return response.data;
  }

  // Settings
  async getSettings() {
    const response = await api.get('/voip/settings');
    return response.data;
  }

  async updateSetting(settingKey, settingValue) {
    const response = await api.patch(`/voip/settings/${settingKey}`, {
      setting_value: settingValue
    });
    return response.data;
  }

  // Astraea Interactions
  async getAstraeaInteractions(filters = {}) {
    const response = await api.get('/voip/astraea/interactions', { params: filters });
    return response.data;
  }

  async createAstraeaInteraction(interactionData) {
    const response = await api.post('/voip/astraea/interactions', interactionData);
    return response.data;
  }

  // WebRTC Helpers
  async createWebRTCSession(extensionId, sessionId, userAgent, ipAddress) {
    const response = await api.post('/voip/webrtc/sessions', {
      extension_id: extensionId,
      session_id: sessionId,
      user_agent: userAgent,
      ip_address: ipAddress
    });
    return response.data;
  }

  async heartbeatWebRTCSession(sessionId) {
    const response = await api.post(`/voip/webrtc/sessions/${sessionId}/heartbeat`);
    return response.data;
  }

  async endWebRTCSession(sessionId) {
    await api.delete(`/voip/webrtc/sessions/${sessionId}`);
  }
}

export const voipService = new VoipService();
export default voipService;
